import React from 'react';
import { Box, Button, Tooltip, useTheme } from '@mui/material';
import { useTeaserContext } from '../TeaserContext';
import { reverseTripStore } from '#/store/ReverseTripStore';
import { formatCurrency } from '#/components/CurrencyFormatter/CurrencyFormatter';
import CachedIcon from '@mui/icons-material/Cached';
import analytics from '#/services/analytics';
import ReverseTripDetailsDialog from './ReverseTripDetailsDialog';
import { useTranslation } from 'react-i18next';
import TranslationStore from '#/store/TranslationStore';
import { jucyBrandPalette, starBrandPalette } from '@jucy-ui/appearance';
import { useFeatureIsOn } from '#/hooks/useFeatureIsOn';

export const ReverseTripDetailButton: React.FC = () => {
    const { deal, fleetCategory, brand } = useTeaserContext();
    const [modalOpen, setModalOpen] = React.useState(false);
    const { t } = useTranslation(TranslationStore.currentNamespace);
    const reverseTripEnabled = useFeatureIsOn('reverse-trip');
    const theme = useTheme();

    if (!deal?.hasCheaperReverseTrip || !deal.reverseTotal || fleetCategory.availability !== 'FreeSell' || !reverseTripEnabled) {
        return null;
    }

    return (
        <>
            <Tooltip title="Click for more details" arrow>
                <Box>
                    <Button
                        onClick={() => {
                            analytics.plugins.interactions.trackInteraction({
                                source: 'OBE',
                                category: 'reverse-trip-details',
                                action: 'click',
                                label: `${fleetCategory.product.code} ${reverseTripStore.trip.pickUpLocation} to ${reverseTripStore.trip.dropOffLocation}`,
                            });
                            setModalOpen(true);
                        }}
                        startIcon={<CachedIcon />}
                        variant="contained"
                        sx={{
                            whiteSpace: 'normal',
                            lineHeight: 1.2,
                            mb: 2,
                            py: 1,
                            px: 2,
                            fontWeight: 'bold',
                            backgroundColor: brand === 'jucy' ? jucyBrandPalette.orange.DEFAULT : starBrandPalette.rock.DEFAULT,
                            color: brand === 'jucy' ? theme.palette.common.white : theme.palette.common.black,
                        }}
                    >
                        {t('fleet_result_list.reverse_trip.show_details_label', {
                            savingsAmount: formatCurrency(deal.reverseTotal),
                        })}
                    </Button>
                </Box>
            </Tooltip>
            <ReverseTripDetailsDialog open={modalOpen} onClose={() => setModalOpen(false)} />
        </>
    );
};
